import classnames from 'classnames';
import LocalizedNoIndexLink from 'components/LocalizedNoIndexLink';
import React from 'react';

const CSS = require('./FilterTrigger.less');

function FilterTrigger({
  isMobile,
  destination,
  text,
  togglePopover,
  isActive,
}) {
  const classes = classnames(CSS.FilterButton, {
    [CSS.FilterButtonIsActive]: isActive,
  });
  const pathObject =
    typeof destination === 'string'
      ? { pathname: destination, state: { modal: true } }
      : destination;
  if (isMobile) {
    return (
      <LocalizedNoIndexLink className={classes} to={pathObject}>
        {text}
      </LocalizedNoIndexLink>
    );
  }
  return (
    <button className={classes} onClick={togglePopover}>
      {text}
    </button>
  );
}

export default FilterTrigger;
